import * as R from 'ramda';
import { useEffect } from 'react';

import { AnalyticsService } from '@/services';
import {
  getUtmParametersCookie,
  parseUtmParameters,
  setUtmParametersCookie,
} from '@/utils';

export const usePersistUtmParameters = () =>
  useEffect(() => {
    const persistUtmParams = () => {
      const existingCookie = getUtmParametersCookie();
      if (!R.isNil(existingCookie)) return;

      const search = window.location.search;
      setUtmParametersCookie(new URLSearchParams(search).toString());

      const utmParams = parseUtmParameters(search);
      AnalyticsService.setUtmParametersAnalytics(utmParams);
    };

    const persistUtmParamsIfConsentGiven = (event: any) => {
      if (event.detail?.accepted?.includes('analytics')) {
        persistUtmParams();
      }
    };

    // Initial call to persist UTM parameters on page load
    persistUtmParams();

    // Listen for consent updates from CookieYes and persist params if consent is given after load
    document.addEventListener(
      'cookieyes_consent_update',
      persistUtmParamsIfConsentGiven,
    );

    return () => {
      document.removeEventListener(
        'cookieyes_consent_update',
        persistUtmParamsIfConsentGiven,
      );
    };
  }, []);
